<template>
	<div class="release-overview">
		<div class="release-employee" v-for="group  in groupEmployeesByEmployeeId(releaseOverviewManager) " :key="group[0].EmployeeID">
			<br>
			<h2 class="employee-name">Employee Name: {{ group[0].EmployeeFirsName + group[0].EmployeeLastName}}</h2>
			<br>
			<ReleaseOvervewManagerTable :releaseOverviewManager="group" />
			<br>
		</div>
	</div>
</template>
<script>
import ReleaseOvervewManagerTable from './release-overview/ReleaseOverviewManagerTable.vue'
  export default {
	name: 'ReleaseOverviewManager',
	components: {
		ReleaseOvervewManagerTable
	},
	beforeMount() {
      this.$store.dispatch("ReleaseOverviewManager");
    },
	computed: {
		releaseOverviewManager: function () {
			return this.$store.state.qtimeReports.releaseOverviewManager;
		}
  },
  methods: {
  groupEmployeesByEmployeeId(employee) {
	let employees = employee;
    const groups = {};
	if(employees!=null){
			employees.forEach(employee => {
		let employeeID = employee.EmployeeID;
		if (!groups[employeeID]) {
		groups[employeeID] = [];
		}
		groups[employeeID].push(employee);
	});
	return Object.values(groups);
	}
    return null;
  }
}
}
</script>
<style scoped>
	.release-overview table td, .release-overview table th,.employee-name,.cta_btn-wrapper {
		padding-left: 49px;
		white-space: nowrap;
		}
		.release-employee {
		box-shadow: 0px 0px 10px 0 rgb(0 0 0 / 35%);
		margin-bottom: 37px;
		}

		.release-employee>div {
			overflow-x: auto;
		}
		
</style>